import request, { download } from '@/utils/request'
import { ElMessage, ElLoading } from 'element-plus';
import { blobValidate } from '@/utils/ruoyi'
import { saveAs } from 'file-saver'

// 查询报名学员列表
export function getStudentList (query, pageInfo) {
  return request({
    url: `/system/student/list?pageSize=${pageInfo.pageSize}&pageNum=${pageInfo.pageNum}`,
    method: 'post',
    headers: { repeatSubmit: false },
    data: query,
    showLoading: true
  })
}
// 查询模拟报名学员列表
export function getSimulateStudentList (query, pageInfo) {
  return request({
    url: `/system/student/simulateList?pageSize=${pageInfo.pageSize}&pageNum=${pageInfo.pageNum}`,
    method: 'post',
    headers: { repeatSubmit: false },
    data: query,
    showLoading: true
  })
}

//查询学生的基本信息
export function getStudentInfo (params) {
  return request({
    url: '/system/student/detail/' + params,
    method: 'get'
  })

}

// 更新报名学员信息
export function updateStudentInfo (data) {
  return request({
    url: '/system/student/update',
    method: 'put',
    data: data
  });
}

//查询学生的出席情况
export function getAttendance (data, pageInfo) {
  return request({
    url: `/system/student/detail/query/attendance`,
    method: 'post',
    headers: { repeatSubmit: false },
    data,
    params: pageInfo
  })
}
//查询学生的课表信息
export function getemailSendRecord (params, pageInfo) {
  return request({
    url: `/system/student/detail/${params}/emailSendRecord?pageSize=${pageInfo.pageSize}&pageNum=${pageInfo.pageNum}`,
    method: 'get'
  })
}
//课表发送信息
export function pushStudentApi (data) {
  return request({
    url: `/system/class/push/student/page`,
    method: 'post',
    data
  })
}
//请求订单情况
export function getOrder (params) {
  return request({
    url: `/system/student/detail/${params}/order`,
    method: 'get'
  })
}

// 查询报名学员跟进记录
export function getStudentFollowInfo (id) {
  return request({
    url: `/system/student/detail/${id}/follow`,
    method: 'get'
  })
}

// 查询报名学员画像足迹信息
export function getStudentTrackInfo (id) {
  return request({
    url: `/system/student/detail/${id}/track`,
    method: 'get'
  });
}

//导出报名学员excel
export function exportStudent (params, filename) {
  let downloadLoadingInstance = ElLoading.service({ text: "正在下载数据，请稍候", background: "rgba(0, 0, 0, 0.7)", })
  if (!filename || typeof filename != 'string') {
    filename = '导出文件'
  }
  return request({
    url: 'system/student/exportData',
    method: 'post',
    responseType: 'blob',
    data: params
  }).then(async (data) => {
    const isBlob = blobValidate(data);
    if (isBlob) {
      const blob = new Blob([data])
      saveAs(blob, filename)
    } else {
      const resText = await data.text();
      const rspObj = JSON.parse(resText);
      const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
      ElMessage.error(errMsg);
    }
    downloadLoadingInstance.close();
  }).catch((r) => {
    console.error(r)
    ElMessage.error('下载文件出现错误，请联系管理员！')
    downloadLoadingInstance.close();
  })

}

// 查询来源渠道下拉树结构
export function sourceTreeSelect (status = '') {
  return request({
    url: '/system/marketChannel/tree',
    method: 'get',
    params: {
      status
    }
  })
}

// 查询意向学员列表
export function getIntentionList (query, pageInfo) {
  return request({
    url: `/system/intention/list?pageSize=${pageInfo.pageSize}&pageNum=${pageInfo.pageNum}`,
    method: 'post',
    headers: { repeatSubmit: false },
    data: query,
    showLoading: true
  })
}

/** 新增意向学员 */
export function insertLead (data) {
  return request({
    url: '/system/intention/insert',
    method: 'post',
    data: data
  });
}

/** 获取意向学员详情 */
export function getLeadInfo (id) {
  return request({
    url: '/system/intention/detail/' + id,
    method: 'get'
  });
}

/** 更新意向学员信息 */
export function updateLeadInfo (data) {
  return request({
    url: '/system/intention/update',
    method: 'put',
    data: data
  });
}

/** 获取意向学员跟进信息 */
export function getLeadFollowInfo (id) {
  return request({
    url: '/system/intention/follow/' + id,
    method: 'get'
  });
}

/** 领取意向学员 */
export function claimLead (id) {
  return request({
    url: '/system/intention/claim/' + id,
    method: 'put'
  });
}

/** 获得证书查询 */
export function findCertInfo (data) {
  return request({
    url: '/system/learnTest/situation/takeCertificateList',
    method: 'post',
    data
  });
}

/** 企微服务人员查询 */
export function findWxChatInfo (id) {
  return request({
    url: `/system/student/wkc/user/${id}`,
    method: 'get',
  });
}


/** 获得学员查询 */
export function studentSearch (data) {
  return request({
    url: '/system/student/search',
    method: 'post',
    data
  });
}


//导出报名学员
export function studentExportList (query) {
  return download(
    `/system/student/exportList`,
    { ...query },
    `报名学员_${new Date().getTime()}.xlsx`,
    { headers: { 'Content-Type': 'application/json' }, }
  );
}

//导出意向学员
export function intentionStudentExportList (query) {
  return download(
    `/system/intention/exportList`,
    { ...query },
    `意向学员_${new Date().getTime()}.xlsx`,
    { headers: { 'Content-Type': 'application/json' }, }
  );
}

/** 删除报名学员实名标识 */
export function deleteIntention (data) {
  return request({
    url: '/system/intention/deleted',
    method: 'put',
    data
  });
}

/** 删除报名学员实名标识 */
export function deletedEqbbs (data) {
  return request({
    url: '/system/student/deletedEqbbs',
    method: 'put',
    data
  });
}


//重复咨询记录
export function duplicateQueryList (data) {
  return request({
    url: '/system/intention/duplicateQueryList',
    method: 'post',
    data,
    showLoading: true
  });
}

// 批量转移
export function stuBatchTrans (data) {
  return request({
    url: '/system/intention/batchTransferLead',
    method: 'post',
    data,
  });
}

// 批量退单、激活
export function stuBatchActDis (data) {
  return request({
    url: '/system/intention/batchActivateLead',
    method: 'post',
    data,
  });
}

// 意向学员批量修改--学员信息批量查询
export function stuBatchQuery (data) {
  return request({
    url: '/system/intention/batchQueryLead',
    method: 'post',
    data,
  });
}

// 意向学员批量修改--提交
export function stuBatchModify (data) {
  return request({
    url: '/system/intention/batchUpdateLead',
    method: 'post',
    data,
  });
}

// 修改记录列表
export function findRecordList (data) {
  return request({
    url: `/system/changeDataInfo/list`,
    method: 'post',
    data
  })
}



// 特殊学员实名认证
export function notNormalUserAuth (data) {
  return request({
    url: `/contract/esign/notNormalUserAuth`,
    method: 'post',
    data
  })
}

/**报名学员-课消流水*/
//课消流水分页查询数据
export function getKxFlowList (data, page) {
  return request({
    url: '/system/student/detail/query/valid/consume',
    method: 'post',
    headers: { repeatSubmit: false },
    data,
    params: page
  })
}

//课消流水页面，获取订单列表
export function getOrderList (id) {
  return request({
    url: `/system/student/detail/query/valid/consume/getOrderList?studentId=${id}`,
    method: 'get',
    headers: { repeatSubmit: false },
  })
}

export function statisticDataIntention () {
  return request({
    url: '/system/intention/statisticData',
    method: 'get',
    headers: { repeatSubmit: false },
    showLoading: true
  })
}

export function statisticDataSign () {
  return request({
    url: '/system/student/statisticData',
    method: 'get',
    headers: { repeatSubmit: false },
    showLoading: true
  })
}

//新增跟进记录
export function insertFollow (data) {
  return request({
    url: '/system/follow/insertFollow',
    method: 'post',
    headers: { repeatSubmit: false },
    data
  })
}

//
//查询跟进记录
export function selectFollowList (data) {
  return request({
    url: '/system/follow/selectFollowList',
    method: 'post',
    headers: { repeatSubmit: false },
    data,
    showLoading: true
  })
}

//意向学员共享
export function addStuTecLinkList (params) {
  return request({
    url: '/system/intention/addStuTecLinkList',
    method: 'get',
    headers: { repeatSubmit: false },
    params: {
      studentId: params.studentId,
      userId: params.userId
    }
  })
}

//意向学员共享-删除
export function deleteStuTecLink (id) {
  return request({
    url: `/system/intention/deleteStuTecLink/${id}`,
    method: 'get',
    headers: { repeatSubmit: false },
  })
}
//意向学员共享-列表
export function getStuTecLinkList (studentId) {
  return request({
    url: `/system/intention/getStuTecLinkList/${studentId}`,
    method: 'get',
    headers: { repeatSubmit: false },
  })
}

//跟进记录修改前时间检测
export function followUpdateCheck (id) {
  return request({
    url: `/system/follow/updateCheck/${id}`,
    method: 'get',
    headers: { repeatSubmit: false },
  })
}

//修改跟进记录
export function updateFollow (data) {
  return request({
    url: '/system/follow/updateFollow',
    method: 'post',
    headers: { repeatSubmit: false },
    data
  })
}


// 承诺书列表
export function studentNotWorkSelectByParam (id) {
  return request({
    url: `/system/student-not-work/selectByParam/${id}`,
    method: 'post',
    headers: { repeatSubmit: false },
  })
}

// 撤回承诺书
export function studentNotWorkCancelNotWork (data = {}) {
  return request({
    url: `/system/student-not-work/cancelNotWork`,
    method: 'post',
    headers: { repeatSubmit: false },
    data
  })
}


// 查询是否挂起
export function schoolPendingInfo(){
  return request({
      url: '/system/intention/schoolPendingInfo',
      method: 'get',
      headers: { repeatSubmit: false },
      showLoading:true
  })
}

// 查询中国标准行业岗位列表
export function selectStandardIndustryApi () {
  return request({
    url: `/system/follow/selectStandardIndustry`,
    method: 'post',
    headers: { repeatSubmit: false },
  })
}

//查询中国标准行业详细岗位列表
export function selectStandardIndustryJobApi () {
  return request({
    url: `/system/follow/selectStandardIndustryJob`,
    method: 'post',
    headers: { repeatSubmit: false },
  })
}

//查询最近时间的根据记录
export function selectFollowOneApi (data) {
  return request({
    url: `/system/follow/selectFollowOne`,
    method: 'post',
    headers: { repeatSubmit: false },
    data
  })
}

// 获取录入分单配置列表接口
export function getConfigList (params) {
  return request({
    url: `/contract/staffPost/getConfigList`,
    method: 'get',
    headers: { repeatSubmit: false },
    params
  })
}

// 更新录入分单配置（只有实际更新了才调用，无修改不用调用更新接口）
export function updateConfig (data) {
  return request({
    url: `/contract/staffPost/updateConfig`,
    method: 'put',
    headers: { repeatSubmit: false },
    data
  })
}